'use client';

import type { ButtonProps } from '@heroui/button';
import { Button } from '@heroui/button';
import { memo } from 'react';
import { type Control, type FieldValues, useFormState } from 'react-hook-form';

interface FormSubmitButtonProps<T extends FieldValues = FieldValues>
    extends Omit<ButtonProps, 'isDisabled' | 'isLoading' | 'type'> {
    control: Control<T>;
    isLoading: boolean;
    children: React.ReactNode;
}

export const FormSubmitButton = memo(function _FormSubmitButton<
    T extends FieldValues = FieldValues,
>({ control, isLoading, children, ...buttonProps }: FormSubmitButtonProps<T>) {
    const { isValid } = useFormState({ control });

    return (
        <Button
            isDisabled={!isValid || isLoading}
            isLoading={isLoading}
            type="submit"
            {...buttonProps}
        >
            {children}
        </Button>
    );
}) as <T extends FieldValues = FieldValues>(
    props: FormSubmitButtonProps<T>
) => JSX.Element;
